import { render, staticRenderFns } from "./SelectOrAddField.vue?vue&type=template&id=525eaa00&"
import script from "./SelectOrAddField.vue?vue&type=script&lang=js&"
export * from "./SelectOrAddField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports